<template>
    <v-card>
        <v-navigation-drawer
        v-model="right_drawer"
        app dark      
        right
        width="400px">   
            <template v-slot:prepend>
                 <v-list-item>
                    <v-list-item-icon>
                       <v-icon> mdi-key </v-icon>
                   </v-list-item-icon>
                   <v-list-item-content>
                       <v-list-item-title class="font-weight-bold">Assign Project Co-editors</v-list-item-title>
                  </v-list-item-content>
                  <v-btn
                  icon
                  @click.stop="close_right_sidebar">
                     <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-list-item>
            </template>
           <v-divider></v-divider>
             <template>
                <v-form
                class="mx-2 my-2"
                ref="form"
                v-model="valid"
                lazy-validation>                                         
                    <v-autocomplete
                    :rules="projectSelectionRules"
                    @change="get_co_editors()"
                    v-model="selected_project"
                    :items="projects"
                    dense
                    filled
                    label="Select Project">
                    </v-autocomplete>
                    <v-chip v-if="this.project_creator"
                    class="mb-2"
                    label
                    dark>
                        <div class="mr-4"> Project Creator:  </div>    {{    project_creator}}
                    </v-chip>
                    <v-combobox
                    v-model="selected_users"
                    :items="available_users"
                    label="Assign co-editors for the selected project"
                    multiple
                    dense
                    filled>
                  </v-combobox>
                  <v-btn
                  color="success"
                  class="mr-6 white--text"
                  @click="store_changes">
                     <v-icon left dark>mdi-content-save</v-icon> Store Changes
                  </v-btn>
                  <v-btn
                  color="error"
                  class="mr-6"
                  @click="reset">
                      <v-icon left dark>mdi-eraser</v-icon> Reset
                  </v-btn>
               </v-form>
            </template>
        </v-navigation-drawer>
        <v-snackbar
         v-model="snackbar"
        :bottom="y === 'bottom'"
        :color="snackbar_color"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'">
        {{ snackbar_text }}
            <v-btn
            dark
            text
            @click="snackbar = false">
            Close
            </v-btn>
        </v-snackbar>
</v-card>




</template>

<script>
    import { componentBus } from '../main';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    export default {
        name: 'AdminConsole',
        data: function () {
            return {
               project_creator: null,
               all_projects_creators: {},
               selected_users: [],
               available_users: [],
               projects: [ ],
               projects_and_editors: {},
               editors: [],
               selected_project: null,
               snackbar_color: '',
               mode: '',
               snackbar: false,
               snackbar_text: '',
               timeout: 4000,
               x: null,
               y: 'top',
               right_drawer: true,
               valid: true,

               projectSelectionRules: [
                //v => !!v || 'You have to select a project'
               v => !!v || 'Range is required',
                ],
            };
        },
        computed: {
            
        },
        methods: {

        get_projects()
        {
         var url_query=APIS_BASE_URL+"/projects/";
         var my_url= encodeURI(url_query);
         axios.get(my_url)
              .then(response => {
                  response.data
                    .forEach(val => {
                      var entry = {
                       text: val.title,
                       value: val.project_uuid
                        };    
                         this.projects.push(entry);    
                         if (val.co_editors!=null)   this.projects_and_editors[entry.value]=val.co_editors;       // for each project store the co-editors     
                         this.all_projects_creators[entry.value]=val.created_by;       // for each project store the creator
                        });  // end of projects loop
                      })  // end of response
                    .catch(error => console.log(error));
           },

        get_co_editors()
        {
         this.project_creator=null;
         this.available_users=[];
         this.selected_users=[];
         let realm_users_url="https://nextgen.iccs.gr/auth/admin/realms/NextGenCMSRealm/users/";
         let encoded_realm_users_url= encodeURI(realm_users_url);
         axios.get(encoded_realm_users_url)
              .then(response => {
                  response.data
                   .forEach(val => {
                      var entry = {
                       text: val.username,
                       value: val.id
                        };    
                        if(this.all_projects_creators[this.selected_project] != entry.value && entry.text!='admin' ) this.available_users.push(entry);    
                        if (this.projects_and_editors[this.selected_project]!=undefined && this.projects_and_editors[this.selected_project].includes(entry.value)  && (this.all_projects_creators[this.selected_project] != entry.value  )  && entry.text!='admin')  this.selected_users.push(entry);
                        if(this.all_projects_creators[this.selected_project]== val.id) this.project_creator=val.username;
                       });  
                       })  // end of response
                    .catch(error => console.log(error));   
        },
        store_changes()
        {
        let valid= this.$refs.form.validate();
        if(valid)
        {   
        //let my_array= this.selected_users.map(x=>x.value);
        
        let payload= {  co_editors: this.selected_users.map(x=>x.value)   };
            
    
        let update_co_editors_url=APIS_BASE_URL+"/projects/"+this.selected_project+"/co_editors/";
        let update_co_editors_url_encoded= encodeURI(update_co_editors_url);

        axios.patch(update_co_editors_url_encoded, payload,
        {
         headers: { 'Content-Type' : 'application/json'}
         }).then(response => {

           if (response.status == "200" || response.status == "201" ) {
           console.log('ola kala');
      
           this.snackbar_color="success";
           this.snackbar_text="Project co-editors have been updated." ;
           this.snackbar=true;
           this.reset();   
            
           }
           else {
           this.snackbar_color="error";
           this.snackbar_text="Problem with updating the Project co-editors..."
           this.snackbar=true;
           }

             
         }).catch(error => {
         this.snackbar_color="error";
         this.snackbar_text="Problem with updating the Project co-editors...Please check your connections"
         this.snackbar=true;
         console.log(error);
        });
        
        }  
        //console.log(this.selected_users);
        },
        reset () 
        {
        this.$refs.form.reset();
        this.all_projects_creators= {};
        this.selected_users=[];
        this.available_users=[];
        this.projects=[];
        this.projects_and_editors= {};
        this.editors= [];
        this.selected_project=null;
        this.project_creator=null;
       
        this.get_projects();

        },
        close_right_sidebar () 
        {
        this.right_drawer = false;
        this.reset();
        }

        },
        mounted() {
        
        componentBus.$on('open_admin_sidebar', (parameter) => {
        console.log(parameter);
        this.$refs.form.reset();
        this.right_drawer = true;
        });

        this.get_projects();
        },
        destroyed() {
          componentBus.$off('open_admin_sidebar');
        }
    };
</script>

<style scoped>
   
</style>
